import { DeleteApiV1EndpointsByEndpointIdApiArg } from /*DeleteApiV1EndpointsByEndpointIdApiResponse,*/ '../../types/courier/endpoints';

import { Endpoint } from '~/features/webhooks/types';
import { courier } from '~/services/serviceInstances';

interface Request {
  endpoint: Endpoint;
}

export const deleteEndpoint = async ({
  endpoint,
}: Request): Promise<boolean> => {
  const param: DeleteApiV1EndpointsByEndpointIdApiArg = {
    endpointId: endpoint.id,
  };

  const response = await courier.remove(`/endpoints/${param.endpointId}`);
  return Boolean(response);
};
